import { IonCol, IonDatetime, IonInput, IonItem, IonLabel, IonRow, isPlatform } from "@ionic/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactDatetimeClass from "react-datetime";
import { FormGroup } from "reactstrap";
import { isWindows } from "../../utilities/platform/Platform";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";

interface _Props {
    onChange: (d: (string | null)) => void;
    label?: string;
    isRequired?: boolean;
    value?: (string | null | undefined);
}

const DatePicker: React.FC<_Props> = ({ label, onChange, isRequired, value }) => {
    // Track date via the format YYYY-MM-DD
    const [date, setDate] = useState<string | null | undefined>(value ? moment(value).format("YYYY-MM-DD") : "");

    useEffect(() => {
        if (value) setDate(value);
        else setDate("");
    }, [value]);

    const handleMobileDateChange = (value: any) => {
        setDate(value);
        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;
        onChange(formattedDate);
    };

    const handleReactDatetimeChange = (date: any) => {
        setDate(date);
        const currentDate = date ? moment(date).format("YYYY-MM-DD") : null;
        onChange(currentDate);
    };

    return (
        <>
            {(isWindows() || isPlatform("desktop")) ? (
                <IonRow>
                    <IonCol>
                        <IonItem color="white">
                            <IonLabel position="stacked">{label ? label : "Date"} {isRequired && <RequiredInputIndicator />}</IonLabel>
                            <IonInput
                                type="date"
                                value={date}
                                onIonChange={e => {
                                    handleReactDatetimeChange(e.detail.value!);
                                }}
                            />
                        </IonItem>
                    </IonCol>
                </IonRow>
            ) : (
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeMd="6" sizeXs="12" className="ion-no-padding">
                        <IonItem>
                            <IonLabel className="text-darker">
                                {label || "Date"} {isRequired && <RequiredInputIndicator />}
                            </IonLabel>
                            <IonDatetime 
                                value={date} 
                                onIonChange={(e) => handleMobileDateChange(e.detail.value!)}>
                            </IonDatetime>
                        </IonItem>
                    </IonCol>
                </IonRow>
            )}
        </>
    );
};

export default DatePicker;
